// extracted by mini-css-extract-plugin
module.exports = {"search_box":"search_box-2hCkKZXy","search_text":"search_text-3Q3rlJFj","sousuo_btn":"sousuo_btn-1jWtzMEB"};